<template>
  <div style="height: 100vh;" :class="storeSetting.body_font + ' black'">            
    <Layout01
      v-if="storeSetting.template_id == 42"
      :tickers="tickers"
      :marqueeList="marqueeList"
      :backgrounds="backgrounds"        
      ref= "layout"
    ></Layout01>  

    <Layout02
      v-if="storeSetting.template_id == 43"
      :tickers="tickers"
      :marqueeList="marqueeList"
      :backgrounds="backgrounds"      
      ref= "layout"
    ></Layout02>

    <Layout03
      v-if="storeSetting.template_id == 44"
      :tickers="tickers"
      :marqueeList="marqueeList"
      :backgrounds="backgrounds"      
      ref= "layout"
    ></Layout03>
 
    <Layout04
      v-if="storeSetting.template_id == 45"
      :tickers="tickers"
      :marqueeList="marqueeList"
      :backgrounds="backgrounds"      
      ref= "layout"
    ></Layout04>

    <Layout05
      v-if="storeSetting.template_id == 79"
      :tickers="tickers"
      :marqueeList="marqueeList"
      :backgrounds="backgrounds"      
      ref= "layout"
    ></Layout05>

    <Layout06
      v-if="storeSetting.template_id == 80"
      :tickers="tickers"
      :marqueeList="marqueeList"
      :backgrounds="backgrounds"      
      ref= "layout"
    ></Layout06>

    <v-container fluid fill-height v-if="loading === true">
      <v-layout align-center justify-center>
        <v-flex xs12 class="white--text display-1 text-xs-center">
              <v-progress-circular
                :size="100"
                :width="10"
                color="lime"
                indeterminate
              ></v-progress-circular>
        <div class="ma-5">{{ $t('search_server') }}</div>
        </v-flex>  
      </v-layout>
    </v-container>  

    <!-- jumbotron container -->
    <transition name="jb-fade">
      <div v-if="jumbotron === true ">
        <v-container fluid fill-height class="absolute pa-0" v-if="jumbotrons.length > 0 && (license == 'pro-se' || license == 'pro' || license == 'demo' || license == 'pcmode')">
          <v-layout row wrap align-center justify-center :style="'background: url(\''+server+'/static/images/jbbg.jpg\') center center no-repeat; background-size: cover;'" >
              
            <img v-if="jumbotrons[jumbotronShown].text && jumbotrons[jumbotronShown].image" style="width:100%;height:auto;" :src="server+'/static/images/jumbotrons/'+ storeSetting.UserId + '/'+jumbotrons[jumbotronShown].image" class="opc5"/>

            <img v-if="!jumbotrons[jumbotronShown].text && jumbotrons[jumbotronShown].image" style="width:100%;height:auto;" :src="server+'/static/images/jumbotrons/'+ storeSetting.UserId + '/'+jumbotrons[jumbotronShown].image"/>
            
            <v-container fluid fill-height class="absolute pa-0" >
              <v-layout row wrap align-center justify-center>
                <v-flex xs10>
                  <div class="text-xs-center yellow--text font-weight-medium jumbotron-text cpb-4" v-html="jumbotrons[jumbotronShown].text ">
                  </div>
                </v-flex>
                <v-flex xs12 class="bottom-clock" v-if="storeSetting.jumbotron_show_clock === true">
                  <v-layout row wrap align-center justify-center>
                    <v-flex xs6>
                      <div class="jumbotron-clock orange--text px-3"><b>{{ clock.format('HH:mm:ss') }}</b></div>          
                    </v-flex>
                    <v-flex xs6 class="text-xs-right orange--text">
                      <span class="jumbotron-next-name font-weight-bold white--text" v-if="nextPraytime">{{ nextPraytime.name }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                      <v-icon color="blue" size="6vh">alarm</v-icon>&nbsp;
                      <span class="jumbotron-next-time pr-3 " >{{ $moment(nextPraytime.time).locale(storeSetting.locale).format('HH:mm') }}</span>
                    </v-flex>
                  </v-layout>
                </v-flex> 
              </v-layout>
            </v-container>
          </v-layout>
        </v-container>            
      </div>
    </transition>

    <!-- demo container -->
    <transition name="jb-fade">
      <v-container fluid fill-height style="position: absolute;top:0;left:0;" v-if="license == 'demo'">
        <v-layout align-center justify-center>
          <v-flex xs12 class="text-xs-center">
            <div class="demo1 font-weight-bold" >Demo Jadwal Sholat Digital</div>          
            <div class="demo2 font-weight-bold white--text">{{ storeSetting.demo_name }}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </transition>

    <!-- toadzan container -->
    <transition name="jb-fade">
      <v-dialog v-model="toAdzan" fullscreen persistent :overlay="false">
        <div class="absolute" style="background-color: rgba(0, 0, 0, 0.65)" v-if="generatedTimer">
          <v-container fill-height class="pa-0">
            <v-flex xs12 class="text-xs-center">
              <v-progress-circular :rotate="360" :size="progressSize" :width="progressWidth" :value="100-(generatedTimer.toward.seconds * 1.666666667)" :color="storeSetting.color_toAdzan" >
                <div class="counter-adzan font-weight-bold white--text">{{ generatedTimer.toward.seconds }}</div>
              </v-progress-circular>  
            </v-flex>
          </v-container>            
        </div>       
      </v-dialog>
    </transition>

    <!-- toiqomah container -->
    <transition name="jb-fade">
      <v-dialog fullscreen class="green lighten-4" v-model="counterBg">    
        <v-layout v-if="storeSetting.toiqomah_bg">
          <v-card width="100vw">          
            <v-img height="100vh" width="100vw" :src="server+'/static/images/settings/'+ storeSetting.UserId + '/' + storeSetting.toiqomah_bg"></v-img>
          </v-card>  
        </v-layout>
        <v-container fluid fill-height class="pa-0 ma-0 absolute">  
          <v-layout row wrap class="align-center justify-center text-xs-center">            
              <div  v-if="toIqomah === true">
                <div class="display-title grey--text text--darken-2" v-if="prevPraytime"><b>{{ $t('toward_iqomah', {prayer:prevPraytime.name}) }}</b>
                </div>
                <div :class="storeSetting.color_toIqomah + '--text display-counter font-weight-bold'">
                  {{ ('000'+ generatedTimer.iqomahCounter.minutes).slice(-2)+':'+('000'+ generatedTimer.iqomahCounter.seconds).slice(-2) }} 
                </div>
              </div>
              <div v-if="goSholat === true && this.strobe === true">
                <div class="display-title grey--text text--darken-2"><b>Waktu Iqomah</b></div>
                <div class="display-sc orange--text font-weight-bold" v-if="prevPraytime">{{ prevPraytime.name }}</div>
              </div>
          </v-layout>
        </v-container>
      </v-dialog>
    </transition>

    <!-- sholatnow container -->
    <transition name="jb-fade">
      <v-dialog fullscreen class="green lighten-4" v-model="sholatNow">
        <div v-if="storeSetting.show_sholat_time === true">
          <v-layout row wrap v-if="prevPraytime">          
            <v-card width="100vw" class="teal darken-3">          
              <v-img height="100vh" width="100vw" :src="server+'/static/images/settings/'+ storeSetting.UserId + '/' + prevPraytime.pause_bg"></v-img>
            </v-card>  
          </v-layout>
          
          <v-container fluid fill-height class="pa-0 ma-0 absolute">  
            <v-layout column wrap class="align-right justify-center text-xs-right cpx-4">
                <div class="sholatnow-title grey--text text--lighten-2"><b>{{ $t('prayer_time') }}</b></div>
                <div :class="storeSetting.color_quiet + '--text sholatnow-name text--lighten-1'" v-if="prevPraytime"><b>{{ prevPraytime.name }}</b></div>
                <div class="sholatnow-clock font-weight-bold black--text" style="margin-top:8vh;">
                  <span style="background:rgba(200,200,200,0.5);border-radius: 8vh;padding: 0 4vh;margin-top:10vh;">{{ clock.format('HH:mm:ss') }}</span>
                </div>
            </v-layout>
          </v-container>
        </div>
        <div v-else>
          <v-img :aspect-ratio="16/9" src="data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs="></v-img>
        </div>
      </v-dialog>      
    </transition>

    <!-- jumatnow container -->
    <transition name="jb-fade">
      <v-dialog fullscreen class="green lighten-4" v-model="jumatNow">
        <div  v-if="storeSetting.show_jumat_time === true">
          <v-layout v-if="storeSetting.jumat_bg">
            <v-card width="100vw" class="teal darken-3">          
              <v-img height="100vh" width="100vw" :src="server+'/static/images/settings/'+ storeSetting.UserId + '/' + storeSetting.jumat_bg"></v-img>
            </v-card>  
          </v-layout>

          <v-container fluid fill-height class="pa-0 ma-0 absolute">  
            <v-layout column wrap class="align-right justify-center text-xs-right cpx-4">
                <div class="sholatnow-title grey--text text--lighten-2"><b>{{ $t('prayer_time_friday') }}</b></div>
                <div :class="storeSetting.color_quiet + '--text sholatnow-name text--lighten-1'"><b>{{ $t('Jumat') }}</b></div>
                <div class="sholatnow-clock font-weight-bold black--text" style="margin-top:8vh;">
                  <span style="background:rgba(200,200,200,0.5);border-radius: 8vh;padding: 0 4vh;margin-top:10vh;">{{ clock.format('HH:mm:ss') }}</span>
                </div>
            </v-layout>
          </v-container>
        </div>
        <div v-else>
          <v-img :aspect-ratio="16/9" src="data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs="></v-img>
        </div>
      </v-dialog>
    </transition>

    <!-- tarawihnow container -->
    <transition name="jb-fade">
      <v-dialog fullscreen class="green lighten-4" v-model="tarawihNow">
        <div v-if="storeSetting.show_tarawih_time === true">
          <v-layout row wrap v-if="prevPraytime">
            <v-card width="100vw" class="teal darken-3" flat>          
              <v-img height="100vh" width="100vw" :src="server+'/static/images/settings/'+ storeSetting.UserId + '/' + storeSetting.tarawih_bg"></v-img>
            </v-card>  
          </v-layout>
          
          <v-container fluid fill-height class="pa-0 ma-0 absolute">  
            <v-layout column wrap class="align-right justify-center text-xs-right cpx-4">
                <div class="sholatnow-title grey--text text--lighten-2"><b>{{ $t('prayer_time_tarawih') }}</b></div>
                <div :class="storeSetting.color_quiet + '--text sholatnow-name text--lighten-1'" ><b>{{ $t('tarawih') }}</b></div>
                <div class="sholatnow-clock font-weight-bold black--text" style="margin-top:8vh;">
                  <span style="background:rgba(200,200,200,0.5);border-radius: 8vh;padding: 0 4vh;margin-top:10vh;">{{ clock.format('HH:mm:ss') }}</span>
                </div>
            </v-layout>
          </v-container>
        </div>
        <div v-else>
          <v-img :aspect-ratio="16/9" src="data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs="></v-img>
        </div>
      </v-dialog>      
    </transition>    

    <!-- VIDEO -->
    <transition name="jb-fade">
      <div v-if="license == 'pro-se' || license == 'demo' || license == 'pcmode'">
        <v-dialog fullscreen v-model="dialogVideo">
          <v-layout class="black">          
            <v-flex xs12 class="black">          
              <div v-if="showLocalVideo" class="video-container">
                <video-player
                  class="vjs-custom-skin video"
                  ref="videoPlayer"
                  :options="playerOptions"
                  :playsinline="true"                     
                  @ended="onPlayerEnded($event)"
                  @ready="playerReadied"
                  >
                </video-player>      
              </div>

              <div v-if="showYoutubeVideo === true" class="video-container">
                <youtube class="video"
                  :fitParent="true"    
                  :resizeDelay="0"      
                  :video-id="youtubeVideoId" 
                  :player-vars="playerVars"           
                  @ended="youtubeEnded"
                  @paused="youtubeEnded"
                  ref="youtube"          
                ></youtube>   
              </div>
            </v-flex>
            <div class="bottom-clock" v-if="storeSetting.video_show_clock === true">
              <v-layout>
                <v-flex xs6>
                  <div class="jumbotron-clock orange--text px-3"><b>{{ clock.format('HH:mm:ss') }}</b></div>          
                </v-flex>
                <v-flex xs6 class="text-xs-right orange--text" v-if="nextPraytime">
                  <span class="jumbotron-next-name font-weight-bold white--text" >{{ $t(nextPraytime.name) }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                  <v-icon color="blue" size="6vh">alarm</v-icon>&nbsp;
                  <span class="jumbotron-next-time pr-3 " >{{ $moment(nextPraytime.time).locale(storeSetting.locale).format('HH:mm') }}</span>
                </v-flex>
              </v-layout>
            </div> 

          </v-layout>
        </v-dialog>  
      </div>
    </transition>
  </div>
</template>

<script>

  import Layout01 from './Layout01'
  import Layout02 from './Layout02'
  import Layout03 from './Layout03'
  import Layout04 from './Layout04'
  import Layout05 from './Layout05'
  import Layout06 from './Layout06'
  import md5 from 'js-md5'
  import 'video.js/dist/video-js.css'
  import { videoPlayer } from 'vue-video-player'
  import { mapState, mapGetters  } from 'vuex'
  import Swal from 'sweetalert2'

  export default {
    
    components:{ Layout01,Layout02,Layout03,Layout04, Layout05,Layout06, videoPlayer },    
    
    data(){
      return {        
        test:true,
        loading:true,
        dialogVideo: false,
        showLocalVideo: false,
        showYoutubeVideo: false,
        khotbah: "",
        tickers:[],
        jumbotrons:[],
        backgrounds:[],        
        schedule:[],
        strobe: false,        
        jumbotronShown: 0,
        jumbotron: false,
        audioAdzan: new Audio,
        audioIqomah:new Audio,
        audioMurottal: new Audio,        
        murottals: [],
        videos:[],        
        //murottal_file_index: 0,
        playingIndex: '',        
        clockInterval:null,        
        groupJumbotron:"",
        marqueeList:'',

        playerOptions: {  
          autoplay: true,
          muted: true,          
          fluid: true,
          responsive: true,
          language: 'en', 
          sources: [{
            type: "video/mp4",
            src: this.server+'/static/videos/def/basmalah.mp4'
          }],
          poster: this.server+'/static/images/app_bg.jpg',
        },

        playerVars: {
          start:0,
          autoplay: 1,
          controls: 0,
          mute:1
        },
        youtubeVideoId:'',        
        duration_between_videos_counter: 360,
        videoShown:0
      }
    },

    sockets:{

      connect(){        
        if(process.env.VUE_APP_SERVED == "client"){          
          setTimeout(()=>{
            this.clientSetTime()  
          }, 8000)
          
        }        
      },

      disconnect(){
        // console.log('disconnected')
      },

      reloadBackground: function(){
        this.getBackgrounds(this.storeSetting.UserId)
        Swal.fire( {title: this.$i18n.t('success'), text:  this.$i18n.t('backgrounds_updated'), type: 'success', timer: 1200, 'showConfirmButton': false })
      },

      reloadTicker: function(){
        this.getTickers(this.storeSetting.UserId)
        Swal.fire( {title:  this.$i18n.t('success'), text: this.$i18n.t('announcements_updated'), type: 'success', timer: 1200, 'showConfirmButton': false })
      },

      reloadJumbotron(){
        this.getJumbotrons(this.storeSetting.UserId)
        Swal.fire( {title:  this.$i18n.t('success'), text: this.$i18n.t('jumbotrons_updated'), type: 'success', timer: 1200, 'showConfirmButton': false })
      },      

      reloadVideo(){
        this.getVideos(this.storeSetting.UserId)
        Swal.fire( {title:  this.$i18n.t('success'), text: this.$i18n.t('videos_updated'), type: 'success', timer: 1200, 'showConfirmButton': false })
      },      

      reloadKhotbah(){
        this.getKhotbah(this.storeSetting.UserId)
        Swal.fire( {title:  this.$i18n.t('success'), text: this.$i18n.t('khotbahs_updated'), type: 'success', timer: 1200, 'showConfirmButton': false })
      },
      
      reloadMurottal(){
        this.getMurottals(this.storeSetting.UserId)
        Swal.fire( {title:  this.$i18n.t('success'), text: this.$i18n.t('murottals_updated'), type: 'success', timer: 1200, 'showConfirmButton': false })
      },

      reloadSetting: async function(data){
        await this.getSetting(data.UserId)
        this.getTodayPraytime(data.UserId)
        Swal.fire( {title:  this.$i18n.t('success'), text: this.$i18n.t('settings_updated'), type: 'success', timer: 1200, 'showConfirmButton': false })
      },

      setClock(){
        this.getTodayPraytime(this.storeSetting.UserId)        
        if(process.env.VUE_APP_SERVED == "client"){
          this.clientSetTime()
        }
      },

      syncClock(){
        this.getTodayPraytime(this.storeSetting.UserId)
        if(process.env.VUE_APP_SERVED == "client"){
          this.clientSetTime()
        }
      },

      showIPWebcam(data){
        this.$router.push('/ipwebcam/' + data)
      },

      stopIPWebcam(){
        this.$router.push({name:'home'})
      },

      showScreen(data){
        this.$router.push('/screen/' + data)
      },

      stopScreen(){
        this.$router.push({name:'home'})
      },

      setLicense(){
        localStorage.removeItem('license')
        localStorage.removeItem('UserId')

        if(process.env.VUE_APP_SERVED  == "online"){
          this.$route.push('wait')
        }
        if(process.env.VUE_APP_SERVED  == "server"){
          setTimeout(()=>{
            this.axios.post('/123now/reboot')
          },2000)
        }
        if(process.env.VUE_APP_SERVED  == "client"){
          setTimeout(()=>{
            this.axios.post('/123now/reboot', { baseURL: "http://localhost:3000"} )
          },2000)
        }
      }    
    },
 
    created(){            
      this.runInit()
    },

    watch:{
      toAdzan(){               
        this.dialogVideo = false
        this.jumbotron = false
      },

      counterBg(){
        this.dialogVideo = false
        this.jumbotron = false        
      },

    },


    computed: {

      progressSize(){return window.innerHeight * 0.7},
      progressWidth(){ return window.innerHeight * 0.16 },

      counterBg(){
        if(this.prevPraytime){
          if (this.prevPraytime.slug != 'jumat'){            
            return ( this.clock.isSameOrAfter(this.$moment(this.prevPraytime.time))  && this.clock.isSameOrBefore(this.$moment(this.prevPraytime.time).add((this.prevPraytime.counter_iqomah *60) + 9, 'seconds')) ) ? true : false
          } else {
            return false
          }
        } return false
      },

      toAdzan(){ 
        if(this.nextPraytime){
          return (this.clock.isSameOrAfter(this.$moment(this.nextPraytime.time).subtract(1, 'minutes')) && this.clock.isBefore(this.$moment(this.nextPraytime.time))) ? true : false   
        } return  false
      },

      goSholat(){
        if(this.prevPraytime){
          if (this.prevPraytime.slug != 'jumat'){
            return (this.clock.isAfter(this.$moment(this.prevPraytime.time).add(this.prevPraytime.counter_iqomah, 'minutes')) && this.clock.isBefore(this.$moment(this.prevPraytime.time).add((this.prevPraytime.counter_iqomah*60) + 9, 'seconds')) ) ? true : false      
          } else {
            return false
          }
        } return false
      }, 

      sholatNow(){
        if(!this.prevPraytime) return false        
        if(this.prevPraytime.slug != 'jumat') {
          return (this.clock.isSameOrAfter(this.$moment(this.prevPraytime.time).add((this.prevPraytime.counter_iqomah *60) +9, 'seconds')) && this.clock.isBefore(this.$moment(this.prevPraytime.time).add((this.prevPraytime.counter_iqomah * 60 ) + 9 + (this.prevPraytime.pause_duration * 60) , 'seconds')) ) ? true : false
        } else {
          return false
        }
      },

      jumatNow(){
        if(!this.prevPraytime) return false
        
        if (this.prevPraytime.slug == 'jumat'){
          return (this.clock.isSameOrAfter(this.$moment(this.prevPraytime.time)) && this.clock.isBefore(this.$moment(this.prevPraytime.time).add(this.storeSetting.jumat_duration, 'minutes')) ) ? true : false
        } else {
          return false
        }
      },  

      tarawihNow(){        
        if(!this.prevPraytime) return false
        
        if( this.$moment().iMonth() == 8 && this.prevPraytime.slug == 'isya'){
          return (this.clock.isSameOrAfter(this.$moment(this.prevPraytime.time).add((this.prevPraytime.counter_iqomah *60) + 9 + (this.prevPraytime.pause_duration * 60), 'seconds')) && this.clock.isBefore(this.$moment(this.prevPraytime.time).add((this.prevPraytime.counter_iqomah * 60 ) + 9 + (this.prevPraytime.pause_duration * 60) + (this.storeSetting.tarawih_duration * 60) , 'seconds')) ) ? true : false
        } else {
          return false
        }
      },      

      ...mapState({
         storeSetting: state => state.setting,
         clock: state => state.clock, 
         server: state => state.server, 
         license: state => state.license,
         licenseNotMatch: state => state.licenseNotMatch 
      }),

      ...mapGetters([
        'nextPraytime', 'prevPraytime', 'generatedTimer', 'toIqomah'
      ])
    },

    methods: {
      clientSetTime(){
        var sta = this.$moment()
        this.axios.get('/datetime') 
        .then(res=>{
          var sto = this.$moment()
          var dur = sto - sta          
          var clk = this.$moment(res.data).add(dur/1000, 'seconds').locale('en').format("YYYY-MM-DD HH:mm:ss")          
          this.axios.post('/123now/datetime-change', { datetime: clk }, { baseURL: "http://localhost:3000" } )
          .then(()=>{
            Swal.fire( {title: this.$i18n.t('success'), text:  this.$i18n.t('settings_updated'), type: 'success', timer: 1200, 'showConfirmButton': false })
          })
          
        })        
      },

      runInit(){
        this.axios.get('/ping')
        .then(()=>{
          this.init()
        })
        .catch(()=>{
          setTimeout(this.init(), 1500)
        })        
      },

      init(){

        let license = this.$route.params.license
        //if ( license === null || license == "" ) this.$router.push('/wait')
        //this.$socket.emit('license', license)

        let UserId = license
      
        this.getSetting(UserId)        
        this.getMurottals(UserId)
        this.getVideos(UserId)
        this.getBackgrounds(UserId)
        this.getTodayPraytime(UserId)
        this.tiktok()
        this.getHolidays()
        // this.$store.dispatch('start')
        this.loading = false
      },

      playYoutubeVideo(file) {
        this.youtubeVideoId = this.$youtube.getIdFromUrl(file) 
        this.showYoutubeVideo = true
        
        setTimeout(()=>{
          this.$refs.youtube.player.playVideo()
          this.$refs.youtube.player.mute()  
        },300)
          
        setTimeout(()=>{
          this.$refs.layout.showFlux = false
          this.$refs.layout.showTicker = false
        },500)
      },
      
      playLocalVideo(file){
        this.playerOptions.sources= [{
          type: "video/mp4",
          src: this.server+'/static/videos/'+ this.storeSetting.UserId + '/' + file
        }],

        this.showLocalVideo = true   
        setTimeout(()=>{
          this.$refs.videoPlayer.player.play()  
          this.$refs.videoPlayer.player.muted() 
        }, 300)

        setTimeout(()=>{
          this.$refs.layout.showFlux = false
          this.$refs.layout.showTicker = false
        }, 500)
      },      
      
      youtubeEnded(){
        this.$refs.layout.showFlux = true
        this.$refs.layout.showTicker = true
        this.videoId = ""    
        setTimeout(()=>{
          this.dialogVideo = false
          this.showYoutubeVideo = false  
        }, 200)
      },

      onPlayerEnded(localPlayer) {
        this.$refs.layout.showFlux = true
        this.$refs.layout.showTicker = true
        localPlayer.currentTime(0)
        setTimeout(()=>{
          this.dialogVideo = false
          this.showLocalVideo = false
        }, 200)
      },       
      
      playerReadied(localPlayer) {
        localPlayer.currentTime(0)
      },

      getTodayPraytime(UserId){
        this.axios.get('/praytimes-today/' + UserId)
        .then(res=>{          
          this.$store.commit('todayPraytime', res.data)
          var maghrib = this.$moment((res.data.filter( p => p.slug == 'maghrib')[0]).time).format('HH:mm')
          this.$store.commit('hijriTurnover', (1440 - (parseInt((maghrib.split(':')[0] * 60)) + parseInt(maghrib.split(':')[1]))))
        })      
      },

      getSetting(UserId){
        // if(this.$refs.layout){
        //   this.$refs.layout.showTicker = false
        //   this.$refs.layout.showFlux = false
        // }
        this.axios.get('/u/settings/'+ UserId)
        .then(res=>{
          // console.log(this.$moment().locale('id').format('x') + '  seting')
          this.$store.commit('setting', res.data)
          this.$moment.locale(res.data.locale)
          this.$i18n.locale = res.data.locale          
          this.groupJumbotron = res.data.jumbotron_group          
          
          setTimeout(()=>{
            this.$refs.layout.showFlux = true            
          }, 1200)

          this.getLicense(UserId)          
        })        
      }, 

      getBackgrounds(UserId){  
        if(this.$refs.layout){         
          this.$refs.layout.showFlux = false
        }
        this.axios.get('/f/backgrounds/' + UserId)
        .then(res=>{          
          this.backgrounds = res.data          
          setTimeout(()=>{                        
            this.$refs.layout.showFlux = true
          }, 1200)
        })        
      }, 

      getKhotbah(UserId){         
        this.axios.get('/khotbahs-next/'+ UserId)
        .then(res=>{          
          let data = res.data
          if( data!="" ){
            this.khotbah = data
            var khotib = (data.Khotib.name) ? "Khotib Jumat (" + this.$moment(data.date).format('DD-MMM-YY') + "): " + data.Khotib.name : ""
            var khotibCity = (data.Khotib.city) ? " dari " + data.Khotib.city : ""
            var muadzin = (data.Muadzin) ? ", Muadzin " + data.Muadzin.name : ""
            var muadzinCity = (data.Muadzin.city) ? " dari " + data.Muadzin.city : ""
            this.khotbah.text = khotib + khotibCity + muadzin + muadzinCity
          }          
          this.getTickers(UserId)
        })        
        
      },

      getTickers(UserId){
        this.axios.get('/f/tickers/'+ UserId)
        .then(res=>{          
          if(this.licenseNotMatch === true){
            this.tickers =  [{text: this.$i18n.t('licenseNotMatch_text1')},{text: this.$i18n.t('licenseNotMatch_text2')}, { text: this.$i18n.t('licenseNotMatch_text3') }]
          } else 
          if(this.noLicense === true){
            this.tickers = [{text: this.$i18n.t('noLicense_text1')},{text: this.$i18n.t('licenseNotMatch_text2')}, { text: this.$i18n.t('licenseNotMatch_text3') }]          
          } else {
            var ft = res.data
            if(this.khotbah != ""){
              if(this.khotbah.ticker === true)  {
                ft = ft.concat({text: this.khotbah.text})            
              }
            }        
            if ( this.license == 'demo'){
              ft = ft.concat({ text: this.$i18n.t('demo_text') })
            }
            this.tickers = ft                        
          }

          var txt = this.tickers.map(i=> i.text)
          this.marqueeList = txt.join('&nbsp; *** &nbsp;')
                    
          this.$refs.layout.showTicker = false
          this.$refs.layout.setTicker()        
          setTimeout(()=>{            
            this.$refs.layout.showTicker = true            
          }, 500)

          this.getJumbotrons(UserId)

        })        
      },  

      getJumbotrons(UserId){
        this.axios.get('/f/jumbotrons/'+ UserId)
        .then(res=>{            
          if (this.license == 'std' ) {
            this.jumbotrons = ''
          } else
          if(this.licenseNotMatch === true){
            this.jumbotrons = [{text: this.$i18n.t('licenseNotMatch_text1')},{text: this.$i18n.t('licenseNotMatch_text2')}, { text: this.$i18n.t('licenseNotMatch_text3') } ]
          } else 
          if(this.noLicense === true){
            this.jumbotrons = [{text: this.$i18n.t('noLicense_text1')},{text: this.$i18n.t('licenseNotMatch_text2')}, { text: this.$i18n.t('licenseNotMatch_text3') } ]
          } else {        
            var fj = res.data            
            if (this.khotbah != ""){
              if(this.khotbah.jumbotron === true){
                fj = fj.concat({text: this.khotbah.text }) 
              }            
            }

            if(this.tickers != ""){
              this.tickers.filter(item=>item.jumbotron == 1)
              .map(i=>{
                fj = fj.concat({ text: i.text })
              })
            }

            if (this.license == 'demo'){
              fj = fj.concat({ text: this.$i18n.t('jumbotron_demo_text') })
            }            
            this.jumbotrons = fj
          }

        })
      },


      getLicense(UserId){        
        let lic = [        
          process.env.VUE_APP_LIC_DEMO,
          process.env.VUE_APP_LIC_STD,
          process.env.VUE_APP_LIC_STD_T1,
          process.env.VUE_APP_LIC_STD_T2,
          process.env.VUE_APP_LIC_STD_T3,
          process.env.VUE_APP_LIC_STD_T4,
          process.env.VUE_APP_LIC_PRO,
          process.env.VUE_APP_LIC_PRO_T1,
          process.env.VUE_APP_LIC_PRO_T2,
          process.env.VUE_APP_LIC_PRO_T3,
          process.env.VUE_APP_LIC_PRO_T4,
          process.env.VUE_APP_LIC_PROSE,
          process.env.VUE_APP_LIC_PROSE_T1,
          process.env.VUE_APP_LIC_PROSE_T2,
          process.env.VUE_APP_LIC_PROSE_T3,
          process.env.VUE_APP_LIC_PROSE_T4
        ]        
        
        this.axios.get('/serial')
        .then(res=>{
          if (res.data.platform == "linode"){
            this.$store.commit('license', 'pro-se') 
          } else {
            if(res.data.serial != ''){
              this.$store.commit('noLicense', false)

              let serial = md5('00000000'+ res.data.serial.substr(-8))

              let lc_demo = '';let lc_std = '';let lc_pro = '';let lc_pro_se = '';
              let lc_std_t1 = '';let lc_std_t2 = '';let lc_std_t3 = '';let lc_std_t4 = '';
              let lc_pro_t1 = '';let lc_pro_t2 = '';let lc_pro_t3 = '';let lc_pro_t4 = '';
              let lc_pro_se_t1 = '';let lc_pro_se_t2 = '';let lc_pro_se_t3 = '';let lc_pro_se_t4 = '';

              
              for (var i = 0; i <= 5; i++) {
                lc_demo += serial.charAt(lic[0].split('')[i])
                lc_std+= serial.charAt(lic[1].split('')[i])
                lc_std_t1 += serial.charAt(lic[2].split('')[i])
                lc_std_t2 += serial.charAt(lic[3].split('')[i])
                lc_std_t3 += serial.charAt(lic[4].split('')[i])
                lc_std_t4 += serial.charAt(lic[5].split('')[i])
                lc_pro += serial.charAt(lic[6].split('')[i])
                lc_pro_t1 += serial.charAt(lic[7].split('')[i])
                lc_pro_t2 += serial.charAt(lic[8].split('')[i])
                lc_pro_t3 += serial.charAt(lic[9].split('')[i])
                lc_pro_t4 += serial.charAt(lic[10].split('')[i])
                lc_pro_se += serial.charAt(lic[11].split('')[i])
                lc_pro_se_t1 += serial.charAt(lic[12].split('')[i])
                lc_pro_se_t2 += serial.charAt(lic[13].split('')[i])
                lc_pro_se_t3 += serial.charAt(lic[14].split('')[i])
                lc_pro_se_t4 += serial.charAt(lic[15].split('')[i])

              }

              var code = this.storeSetting.license
              // console.log(this.$moment().format('x') + '  code')

              if(code == lc_demo){
                this.$store.commit('license', 'demo')
              } else if( code == lc_std ){
                this.$store.commit('license', 'std') 
              } else if( code == lc_std_t1 ){
                this.$store.commit('license', 'std')
                this.axios.put('/f/settings-single-template', {template_id: 42, UserId: this.storeSetting.UserId})
              } else if( code == lc_std_t2 ){
                this.$store.commit('license', 'std') 
                this.axios.put('/f/settings-single-template', {template_id: 43, UserId: this.storeSetting.UserId})
              } else if( code == lc_std_t3 ){
                this.$store.commit('license', 'std') 
                this.axios.put('/f/settings-single-template', {template_id: 44, UserId: this.storeSetting.UserId})
              } else if( code == lc_std_t4 ){
                this.$store.commit('license', 'std') 
                this.axios.put('/f/settings-single-template', {template_id: 45, UserId: this.storeSetting.UserId})
              } else if( code == lc_pro ){              
                this.$store.commit('license', 'pro') 
              } else if( code == lc_pro_t1 ){
                this.$store.commit('license', 'pro') 
                this.axios.put('/f/settings-single-template', {template_id: 42, UserId: this.storeSetting.UserId})
              } else if( code == lc_pro_t2 ){
                this.$store.commit('license', 'pro') 
                this.axios.put('/f/settings-single-template', {template_id: 43, UserId: this.storeSetting.UserId})
              } else if( code == lc_pro_t3 ){
                this.$store.commit('license', 'pro') 
                this.axios.put('/f/settings-single-template', {template_id: 44, UserId: this.storeSetting.UserId})
              } else if( code == lc_pro_t4 ){
                this.$store.commit('license', 'pro') 
                this.axios.put('/f/settings-single-template', {template_id: 45, UserId: this.storeSetting.UserId})
              } else if( code == lc_pro_se ){              
                this.$store.commit('license', 'pro-se')
              } else if( code == lc_pro_se_t1 ){
                this.$store.commit('license', 'pro-se') 
                this.axios.put('/f/settings-single-template', {template_id: 42, UserId: this.storeSetting.UserId})
              } else if( code == lc_pro_se_t2 ){
                this.$store.commit('license', 'pro-se') 
                this.axios.put('/f/settings-single-template', {template_id: 43, UserId: this.storeSetting.UserId})
              } else if( code == lc_pro_se_t3 ){
                this.$store.commit('license', 'pro-se') 
                this.axios.put('/f/settings-single-template', {template_id: 44, UserId: this.storeSetting.UserId})
              } else if( code == lc_pro_se_t4 ){
                this.$store.commit('license', 'pro-se') 
                this.axios.put('/f/settings-single-template', {template_id: 45, UserId: this.storeSetting.UserId})
              } else {
                this.$store.commit('licenseNotMatch', true)
              }
            } else {
              this.$store.commit('license', 'pcmode')
            }
          }          
          this.getKhotbah(UserId)
        })
      },      

      selectJumbotron(){
        this.jumbotrons[this.jumbotronShown++]
        if (this.jumbotronShown >= this.jumbotrons.length) this.jumbotronShown = 0;
                
          setTimeout(()=>{
            this.jumbotron = true
            }, 20)
          setTimeout(()=>{
            this.jumbotron = false
            if(this.groupJumbotron - 1 > 0){
              this.selectJumbotron()
              this.groupJumbotron--
            } else {              
              this.groupJumbotron = this.storeSetting.jumbotron_group
              this.jumbotron = false
            }
          }, this.storeSetting.jumbotron_duration * 1000);
      },

      getMurottals(uid){
        this.axios.get('/f/murottals/' + uid)
        .then(res=>{
          this.murottals = res.data          
        })        
      },   

      getVideos(uid){
        this.axios.get('/f/videos/' + uid)
        .then(res=>{ 
          if(process.env.VUE_APP_SERVED == "online"){
            this.videos = res.data    
          } else {
             this.videos = res.data.filter(i=>i.type == 'local')
          }          
          
        })        
      },   

      getHolidays(){
        this.axios.get('/f/holidays')
        .then(res=>{
          this.$store.commit('holidays', res.data)          
        })
      },  

      blink(){
        this.strobe = false
        setTimeout(()=>{this.strobe = true}, 300);
      },

      getClock(){
        this.$store.commit('clock', this.$moment())
        if(this.goSholat === true) this.blink()        

        if (this.$moment().format('s') == 0) this.getHolidays()

        if(this.license == 'pro-se' || this.license == 'pro' || this.license == 'demo' || this.license == 'pcmode'){
          if ( (parseInt(this.$moment().format('X'))-6) % this.storeSetting.jumbotron_periode == 0) {
            if(
              this.dialogVideo === false &&
              this.toAdzan === false &&
              this.counterBg === false &&            
              this.sholatNow === false &&
              this.jumatNow === false
              ){
              this.selectJumbotron()            
            }
          }        
        }

        if(this.license == 'pro-se' || this.license == 'demo' || this.license == 'pcmode'){
          this.duration_between_videos_counter = this.duration_between_videos_counter - 1   //countdown     
          if ( this.duration_between_videos_counter <= 0 && this.videos.length > 0){ //time to show
            if (              
              this.toAdzan === false &&          
              this.counterBg === false &&
              this.sholatNow === false &&
              this.jumatNow === false
            ){

              this.jumbotron = false
              this.duration_between_videos_counter = this.storeSetting.video_pause_between        

              var playon = this.videos[this.videoShown++]          
              if (this.videoShown >= this.videos.length) this.videoShown = 0;          
              this.dialogVideo = true
              if(playon.type == "local"){
                this.showYoutubeVideo = false
                this.playLocalVideo(encodeURI(playon.file))              
              } else if (playon.type == "youtube"){              
                this.showLocalVideo = false
                this.playYoutubeVideo(encodeURI(playon.file))              
              }
            }
          }
        }

        if(this.nextPraytime) {

          if(this.nextPraytime.start >0){
            if (this.$moment().format('X') == this.$moment(this.nextPraytime.time).subtract(this.nextPraytime.start, 'minutes').format('X') ){              
              this.playingIndex = this.murottals.findIndex(item=> {return item.id == this.nextPraytime.murottal.id} )              
              this.dialogVideo = false
              this.playMurottal()
            }
          }

          if(this.$moment().format('X') == this.$moment(this.nextPraytime.time).format('X')) {
            
            if(this.storeSetting.buzzer_adzan !== null) {              
              this.axios.get('/f/buzzer/'+this.storeSetting.buzzer_adzan, { baseURL: "http://localhost:3000" })
            }            

            if(this.nextPraytime.adzan.filename != ""){
              this.audioMurottal.pause()
              this.dialogVideo = false
              this.audioAdzan.src = this.server+'/static/adzan/'+ this.nextPraytime.adzan.filename                            
              this.audioAdzan.muted = false
              this.audioAdzan.volume = 0.9
              this.audioAdzan.load()
              this.audioAdzan.play()
            }

            this.getTodayPraytime(this.storeSetting.UserId)
            this.getMurottals(this.storeSetting.UserId)
          }

          if(parseInt(this.clock/1000) == this.$moment(this.nextPraytime.time).subtract(this.nextPraytime.stop, 'minutes')/1000){
            this.audioMurottal.pause()
          }
        }

        if(this.prevPraytime) {
          if(this.clock.format('hh:mm:ss') == this.$moment(this.prevPraytime.time).add(this.prevPraytime.counter_iqomah, 'minutes').format('hh:mm:ss') ){
            
            if(this.storeSetting.buzzer_iqomah !== null) {              
              this.axios.get('/f/buzzer/'+this.storeSetting.buzzer_iqomah, { baseURL: "http://localhost:3000" })
            }
                        
            this.audioAdzan.pause()
            this.dialogVideo = false
            if(this.prevPraytime.slug != 'jumat'){
              this.audioIqomah.src = this.server+'/static/iqomah/'+ this.prevPraytime.iqomah.filename                            
              this.audioIqomah.muted = false
              this.audioIqomah.volume = 0.9
              this.audioIqomah.load()
              this.audioIqomah.play()
            }
          }
        }        
      },

      tiktok(){
        this.clockInterval = setInterval((this.getClock),1000)
        // this.$store.dispatch('start')
      },

      playMurottal(){
        if (this.playingIndex >= this.murottals.length) this.playingIndex = 0          
        var entry = this.murottals[this.playingIndex]        
        this.audioMurottal.src = this.server + '/static/murottals/'+ this.storeSetting.UserId + '/' + entry.QoriId +'/'+ entry.filename                         
        this.audioMurottal.muted = false
        this.audioMurottal.volume = 0.9
        this.audioMurottal.load()
        this.audioMurottal.play()
        this.audioMurottal.onended = () => {           
          this.playNextMurottal()
        }
      },

      stopMurottal(){
        //this.settings.murottal_current_time = ct.toString()        
        // this.axios.put('/settings/1', this.settings)
        // .then(res=>{
          this.audioMurottal.pause()
          
        // })
      },

      playNextMurottal(){
        if (this.storeSetting.mrt_next == 0){ // stop
          this.audioMurottal.pause()
        } else if (this.storeSetting.mrt_next == 1){ // next
          this.playingIndex =  this.playingIndex + 1            
          this.playMurottal()
        } else if (this.storeSetting.mrt_next == 2){ // repeat
          this.playMurottal()
        }        
      },

    },

    beforeDestroy(){
      clearInterval(this.clockInterval)      
    }
  }  
</script>

<style>

  .video-container {    
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
  }

  .video{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .abs-bottom{position: absolute; bottom:0; width:100%; } 
  .absolute{ position: absolute; top:0; left:0; width:100%; height:100%; }

  .aladin {font-family: Aladin;}
  .eczar {font-family: Eczar;}
  .roboto {font-family: Roboto;}
  .oleo {font-family: "Oleo Script";}
  .led {font-family: Led;}  

  .opc0, .opc0.v-card {background-color: transparent;}
  .opc5{background-color: rgba(255, 255, 255, 0.5); } 
  .opc7{background-color: rgba(255, 255, 255, 0.7); } 
  .greenopc8{background-color: rgba(0, 30, 0, 0.8); }   

  @media all and (orientation:landscape) {
    .swal2-popup{
      font-family: Roboto !important;
      font-size: 2.4vh !important;
    }

    .bottom-clock{background-color: rgba(0, 0, 0, 0.8); height:10vh;bottom:0;width:100%;position: absolute; }

    .blackopc, .blackopc.v-card{background-color: rgba(0, 0, 0, 0.5);text-shadow: 0 0 2.5vh #000;}
    .whiteopc, .whiteopc.v-card{background-color: rgba(255, 255, 255, 0.6);text-shadow: 0 0 2.5vh #000;}
    .purpleopc, .purpleopc.v-card{background-color: rgba(156, 39, 176, 0.5);text-shadow: 0 0 2.5vh #000;}
    .tealopc,  .tealopc.v-card{background-color: rgba(0, 150, 136, 0.5);text-shadow: 0 0 2.5vh #000;}
    .orangeopc, .orangeopc.v-card{background-color: rgba(255, 152, 0, 0.5);text-shadow: 0 0 2.5vh #000;}
    .redopc, .redopc.v-card{background-color: rgba(244, 67, 54, 0.5);text-shadow: 0 0 2.5vh #000;}
    .greenopc, .greenopc.v-card{background-color: rgba(76, 175, 80, 0.5);text-shadow: 0 0 2.5vh #000;}
    .blueopc, .blueopc.v-card{background-color: rgba(33, 150, 243, 0.5); text-shadow: 0 0 2.5vh #000;}
    .greyopc, .greyopc.v-card{background-color: rgba(155, 155, 155, 0.7);}

    .jumbotron-text{ text-shadow: 0px 0px 2.5vh #000;font-size:10vh; line-height:10vh;}
    .jumbotron-clock{font-size:9vh; line-height:9vh; } 
    .jumbotron-next-name{font-size:6vh;line-height:5vh;}
    .jumbotron-next-time{font-size:8vh;line-height:8vh;}    

    .display-title{ font-size: 13vh;line-height:13vh; text-shadow: 0 0 2vh #FFD, 0 0 1vh #FFD,0 0 1vh #FFD,0 0 1vh #FFD; }
    .display-counter{ font-size: 50vh; line-height:50vh; text-shadow: 0 0 2vh #222, 0 0 2vh #222,0 0 2vh #222;}
    .display-sc{ font-size: 40vh; line-height:40vh; text-shadow: 0 0 2vh #222, 0 0 2vh #222,0 0 2vh #222;}

    .sholatnow-title{font-size:12vh;line-height: 12vh; text-shadow: 0 0 2.5vh #000;}
    .sholatnow-name{font-size:30vh;line-height: 30vh; text-shadow: 0 0 2.5vh #000;}
    .sholatnow-clock{font-size:20vh;line-height: 20vh;}

    .demo1{ font-size: 6vh; line-height: 6vh; opacity: 0.5;text-shadow: 0 0 2vh #FFD, 0 0 1vh #FFD,0 0 1vh #FFD,0 0 1vh #FFD;}
    .demo2{ font-size: 12vh; line-height: 12vh; opacity: 0.35;text-shadow: 0 0 2vh #111, 0 0 1vh #111,0 0 1vh #111,0 0 1vh #111; }

    .cmx-05{margin-left:0.5vh;margin-right:0.5vh;}
    .cmx-1{margin-left:1vh;margin-right:1vh;}
    .cmx-2{margin-left:2vh;margin-right:2vh;}
    .cmx-15{margin-left:1.5vh;margin-right:1.5vh;}
    .cmy-05{margin-top:0.5vh;margin-bottom:0.5vh;}
    .cmy-1{margin-top:1vh;margin-bottom:1vh;}
    .cmy-15{margin-top:1.5vh;margin-bottom:1.5vh;}

    .cmt-1{margin-top:1vh;}
    .cmb-1{margin-bottom:1vh;}
    .cmb-15{margin-bottom:1.5vh;}
    .cmb-2{margin-bottom:2vh;}
    .cmt-2{margin-top:2vh;}
    .cmr-2{margin-right:2vh;}

    .cpa-1{padding:1vh;}
    .cpa-2{padding:2vh;}
    .cpa-3{padding:3vh;}
    .cpa-4{padding:4vh;}

    .cpx-05{ padding-left: 0.5vh; padding-right: 0.5vh;}
    .cpx-1{ padding-left: 1vh; padding-right: 1vh;}
    .cpx-15{ padding-left: 1.5vh; padding-right: 1.5vh;}
    .cpx-2{ padding-left: 2vh; padding-right: 2vh;}
    .cpx-3{ padding-left: 3vh; padding-right: 3vh;}
    .cpx-4{ padding-left: 4vh; padding-right: 4vh;}

    .cpy-05{ padding-top: 0.5vh; padding-bottom: 0.5vh;}
    .cpy-1{ padding-top: 1vh; padding-bottom: 1vh;}
    .cpy-15{ padding-top: 1.5vh; padding-bottom: 1.5vh;}
    .cpy-2{ padding-top: 2vh; padding-bottom: 2vh;}
    .cpy-3{ padding-top: 3vh; padding-bottom: 3vh;}
    .cpy-4{ padding-top: 4vh; padding-bottom: 4vh;}

    .cpt-1{ padding-top: 1vh;}
    .cpt-2{ padding-top: 2vh;}
    .cpt-3{ padding-top: 3vh;}
    .cpt-4{ padding-top: 4vh;}

    .cpb-1{ padding-bottom: 1vh;}
    .cpb-2{ padding-bottom: 2vh;}
    .cpb-3{ padding-bottom: 3vh;}
    .cpb-4{ padding-bottom: 4vh;}

    .cpl-1{ padding-left: 1vh;}
    .cpl-2{ padding-left: 2vh;}
    .cpl-3{ padding-left: 3vh;}
    .cpl-4{ padding-left: 4vh;}

    .cpr-1{ padding-right: 1vh;}
    .cpr-2{ padding-right: 2vh;}
    .cpr-3{ padding-right: 3vh;}
    .cpr-4{ padding-right: 4vh;}

    .black-shadow1{text-shadow: 0 0 1vh #000}
    .black-shadow2{text-shadow: 0 0 1vh #000,0 0 1vh #000;}
    .black-shadow3{text-shadow: 0 0 1vh #000,0 0 1vh #000,0 0 1.5vh #000;}

    .white-shadow1{text-shadow: 0 0 1vh #FFF}
    .white-shadow2{text-shadow: 0 0 1vh #FFF,0 0 1.5vh #FFF;}
    .white-shadow3{text-shadow: 0 0 1vh #FFF,0 0 1.5vh #FFF,0 0 2vh #FFF;}

    .counter-adzan{font-size:22vh; text-shadow:0 0 4vh #000000; }

  }

  @media all and (orientation:portrait) {
    .swal2-popup{
      font-family: Roboto !important;
      font-size: 1.35vw !important;
    }

    .blackopc, .blackopc.v-card{background-color: rgba(0, 0, 0, 0.5);text-shadow: 0 0 1.40625vw #000;}
    .whiteopc, .whiteopc.v-card{background-color: rgba(255, 255, 255, 0.6);text-shadow: 0 0 1.40625vw #000;}
    .purpleopc, .purpleopc.v-card{background-color: rgba(156, 39, 176, 0.5);text-shadow: 0 0 1.40625vw #000;}
    .tealopc,  .tealopc.v-card{background-color: rgba(0, 150, 136, 0.5);text-shadow: 0 0 1.40625vw #000;}
    .orangeopc, .orangeopc.v-card{background-color: rgba(255, 152, 0, 0.5);text-shadow: 0 0 1.40625vw #000;}
    .redopc, .redopc.v-card{background-color: rgba(244, 67, 54, 0.5);text-shadow: 0 0 1.40625vw #000;}
    .greenopc, .greenopc.v-card{background-color: rgba(76, 175, 80, 0.5);text-shadow: 0 0 1.40625vw #000;}
    .blueopc, .blueopc.v-card{background-color: rgba(33, 150, 243, 0.5); text-shadow: 0 0 1.40625vw #000;}
    .greyopc, .greyopc.v-card{background-color: rgba(155, 155, 155, 0.7); text-shadow: 0 0 1.40625vw #000;}

    .jumbotron-text{ text-shadow: 0 0 1.40625vw #000;font-size:5.625vw; line-height:5.625vw;}
    .jumbotron-clock{font-size:5.0625vw; line-height:5.0625vw;}
    .jumbotron-next-name{font-size:3.375vw;line-height:2.8125vw;}
    .jumbotron-next-time{font-size:4.5vw;line-height:4.5vw;}

    .display-title{ font-size: 7.3125vw;line-height:7.3125vw; text-shadow: 0 0 1.125vw #FFD, 0 0 0.5625vw #FFD,0 0 0.5625vw #FFD,0 0 0.5625vw #FFD; }
    .display-counter{ font-size: 28.125vw; line-height:28.125vw; text-shadow: 0 0 1.125vw #222, 0 0 1.125vw #222,0 0 1.125vw #222;}
    .display-sc{ font-size: 22.5vw; line-height:22.5vw; text-shadow: 0 0 1.125vw #222, 0 0 1.125vw #222,0 0 1.125vw #222;}

    .sholatnow-title{font-size:11.125vw;line-height: 11.125vw; text-shadow: 0 0 1.40625vw #000;}
    .sholatnow-name{font-size:16.875vw;line-height: 16.875vw; text-shadow: 0 0 1.40625vw #000;}
    .sholatnow-clock{font-size:11.25vw;line-height: 11.25vw;}

    .demo1{ font-size: 3.375vw; line-height: 3.375vw; opacity: 0.5;text-shadow: 0 0 1.125vw #FFD, 0 0 0.5625vw #FFD,0 0 0.5625vw #FFD,0 0 0.5625vw #FFD;}
    .demo2{ font-size: 11.125vw; line-height: 11.125vw; opacity: 0.35;text-shadow: 0 0 1.125vw #111, 0 0 0.5625vw #111,0 0 0.5625vw #111,0 0 0.5625vw #111; }

    .cmx-05{margin-left:0.28125vw;margin-right:0.28125vw;}
    .cmx-1{margin-left:0.5625vw;margin-right:0.5625vw;}
    .cmx-2{margin-left:1.125vw;margin-right:1.125vw;}
    .cmx-15{margin-left:0.84375vw;margin-right:0.84375vw;}
    .cmy-05{margin-top:0.28125vw;margin-bottom:0.28125vw;}
    .cmy-1{margin-top:0.5625vw;margin-bottom:0.5625vw;}
    .cmy-15{margin-top:0.84375vw;margin-bottom:0.84375vw;}

    .cmt-1{margin-top:0.5625vw;}
    .cmb-1{margin-bottom:0.5625vw;}
    .cmt-2{margin-top:1.125vw;}
    .cmr-2{margin-right:1.125vw;}

    .cpa-1{padding:0.5625vw;}
    .cpa-2{padding:1.125vw;}
    .cpa-3{padding:1.6875vw;}
    .cpa-4{padding:2.25vw;}

    .cpx-05{ padding-left: 0.28125vw; padding-right: 0.28125vw;}
    .cpx-1{ padding-left: 0.5625vw; padding-right: 0.5625vw;}
    .cpx-15{ padding-left: 0.84375vw; padding-right: 0.84375vw;}
    .cpx-2{ padding-left: 1.125vw; padding-right: 1.125vw;}
    .cpx-3{ padding-left: 1.6875vw; padding-right: 1.6875vw;}
    .cpx-4{ padding-left: 2.25vw; padding-right: 2.25vw;}

    .cpy-05{ padding-top: 0.28125vw; padding-bottom: 0.28125vw;}
    .cpy-1{ padding-top: 0.5625vw; padding-bottom: 0.5625vw;}
    .cpy-15{ padding-top: 0.84375vw; padding-bottom: 0.84375vw;}
    .cpy-2{ padding-top: 1.125vw; padding-bottom: 1.125vw;}
    .cpy-3{ padding-top: 1.6875vw; padding-bottom: 1.6875vw;}
    .cpy-4{ padding-top: 2.25vw; padding-bottom: 2.25vw;}

    .cpt-1{ padding-top: 0.5625vw;}
    .cpt-2{ padding-top: 1.125vw;}
    .cpt-3{ padding-top: 1.6875vw;}
    .cpt-4{ padding-top: 2.25vw;}

    .cpb-1{ padding-bottom: 0.5625vw;}
    .cpb-2{ padding-bottom: 1.125vw;}
    .cpb-3{ padding-bottom: 1.6875vw;}
    .cpb-4{ padding-bottom: 2.25vw;}

    .cpl-1{ padding-left: 0.5625vw;}
    .cpl-2{ padding-left: 1.125vw;}
    .cpl-3{ padding-left: 1.6875vw;}
    .cpl-4{ padding-left: 2.25vw;}

    .cpr-1{ padding-right: 0.5625vw;}
    .cpr-2{ padding-right: 1.125vw;}
    .cpr-3{ padding-right: 1.6875vw;}
    .cpr-4{ padding-right: 2.25vw;}

    .black-shadow1{text-shadow: 0 0 0.5625vw #000}
    .black-shadow2{text-shadow: 0 0 0.5625vw #000,0 0 0.5625vw #000;}
    .black-shadow3{text-shadow: 0 0 0.5625vw #000,0 0 0.5625vw #000,0 0 0.84375vw #000;}

    .white-shadow1{text-shadow: 0 0 0.5625vw #FFF}
    .white-shadow2{text-shadow: 0 0 0.5625vw #FFF,0 0 0.84375vw #FFF;}
    .white-shadow3{text-shadow: 0 0 0.5625vw #FFF,0 0 0.84375vw #FFF,0 0 1.125vw #FFF;}

    .counter-adzan{font-size:12.375vw; text-shadow:0 0 2.25vw #000000; }

  }  


  /* TRANSITION */
  .jb-fade-enter-active, .jb-fade-leave-active{transition: 1s;}
  .jb-fade-enter, .jb-fade-leave-to{opacity: 0;}

/*  .slideleft-enter-active, .slideleft-leave-active, .slideleft-leave-to{transition: 0.5s;position: absolute;top: 0;left: 0;}
  .slideleft-leave-to {transform: translate3d(-100%, 0, 0)}
  .slideleft-enter, .slideleft-leave{transform: translate3d(100%, 0, 0); }

  .slideup-enter-active, .slideup-leave-active{transition: 0.5s;position: absolute;top: 0;left: 0;} 
  .slideup-leave-to{transform: translate3d(0, -100%,0); opacity: 0;}
  .slideup-enter{transform: translate3d(0, 100%,0); opacity: 0;} */

  @font-face {
     font-family: 'Uthmanic';font-style: normal;font-weight: 400;     
     src: url('../assets/fonts/Amiri-Regular.ttf') format('truetype');
  }

  @font-face {
     font-family: 'Led';font-style: normal;font-weight: 400;     
     src: url('../assets/fonts/led.woff2') format('woff2');
  }  

  @font-face {
    font-family: 'Oleo Script';
    font-style: normal;
    font-weight: 400;
    src: url(../assets/fonts/oleo-script.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
</style>